import { render } from "./footer.vue?vue&type=template&id=7227c002&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=7227c002&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7227c002"]])

export default __exports__